import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightToBracket } from "@fortawesome/free-solid-svg-icons";
import { useSearchParams } from "react-router-dom";
import { useCookies } from "react-cookie";
import ExternalAuth from "./ExternalAuth";
import axios from "axios";

function Login() {

  const [searchParams, setSearchParams] = useSearchParams();
  const [cookies, setCookie, removeCookie] = useCookies(['biz_outh_srv']);

  const [userData, setUserData] = useState(null);

  function userDataLoad() {
    axios.get('/api/user/get')
      .then((res) => {
        if (res.data.Status === 1) {
          setUserData(res.data.Data);
        }
      })
      .catch((error) => {

      });
  }
  useEffect(() => {
    const srv = searchParams.get("srv")
    if (srv !== null) {
      setCookie('biz_outh_srv', srv)
    }
    userDataLoad();
  }, []);

  //Переменные
  const [log, setLog] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [login, setLogin] = useState(null);
  const [password, setPassword] = useState(null);

  const handlerLogin = (event) => {
    setLog(null);
    setLoading(true);

    if (login === null || login === '' || login === undefined) {
      setLog('Введите Еmail или номер телефона');
      setLoading(false);
    }
    else if (password === null || password === '' || password === undefined) {
      setLog('Введите пароль');
      setLoading(false);
    }
    else {
      axios.post('/api/user/login', { login: login, password: password })
        .then((res) => {
          if (res.data.Status === 1) {
            setLoading(false);
            const srv = cookies.biz_outh_srv;
            //Если трекер
            if (srv === 2) {
              return window.location.replace(process.env.REACT_APP_DOMAIN_TRACKER + '/lk');
            }
            else {
              userDataLoad();
            }
          }
          else {
            setLog(res.data.Error);
            setLoading(false);
          }
        })
        .catch((error) => {
          setLog('Неизвестная ошибка!');
          setLoading(false);
        });
    }
  };



  useEffect(() => {
    // Получаем строку запроса (часть после ?)
    const queryString = window.location.search;

    //const url = 'https://biz-office.ru/?code=vk2.a.LFHUzzjwCCam_zxtCNL-B_OP-5BT5F-nQNxR0s4FMi9DSA2uJDcoeE3TCu41J4czDqbOqrcBdh6nfZhqXRL1OenIGTUZNJyJhNhHfHW8jFUjsUdPNeSz-Srizlav9E4tWBeLTyhPnitm2bwkt5NyE-BeU6kmeynLNF8rYUzpm2FToFQJGCZqO73cx3Ur88RMmSeVWJoG02T0B1Y4L7w04yCMB39VZy9hoZe37cQu8ms&expires_in=600&device_id=Pg0JTAnK0H1MIkUQUrRz7qBFaBmEdKD-E6KU9xmE9xJmi8xYfzz9JZdSNDIIrhk8ZHLCSkdJ4siZm8cs9E3GWg&state=67236b1c-ab15-4629-a2c8-91bff61ac0c9&ext_id=u_5pMLVLtbVgzfE0RbwUyu1-iS8890JguOJbfP-et87zZJblnxxHe1EYDjApJyrWpn_QyijlTfUozTwP9bob7ZQqHOEWw_80FJw518bh6zWtid5lvHfbIu8ffT5YUf4G-np1kP34n8DDOjLzfsMIKNq_o2Ibjk2nKDMmFfFeDMhm&type=code_v2'
    // Создаем объект URLSearchParams для разбора
    const urlParams = new URLSearchParams(queryString);

    // Извлекаем значение параметра 'paramName'
    const device_id = urlParams.get('device_id');
    const code = urlParams.get('code');
    const state = urlParams.get('state');

    const json = {
      "device_id": device_id,
      "code": code,
      "state": state,

    }

    console.log(json)
    /*
    {
      "device_id": "string",
      "code": "string",
      "state": "string",
      "promo": "string"
    }
    */



  }, []);


  return (
    <>
      {userData === null ? (
        <Container>
          <h1 className="text-center mt-3 mt-lg-5 mb-3 mb-lg-5">Вход в сервис</h1>
          <div className="row">
            <div className="col-lg-4"></div>
            <div className="col-lg-4">
              <div className="block_form">
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control type="email" disabled={isLoading} onChange={(e) => setLogin(e.target.value)} />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Пароль</Form.Label>
                  <Form.Control type="password" disabled={isLoading} onChange={(e) => setPassword(e.target.value)} />
                </Form.Group>
                <div className="row">
                  <div className="col-lg-12 text-center">
                    <Button
                      type="button"
                      variant="light"
                      disabled={isLoading}
                      className="btn_form"
                      onClick={() => handlerLogin()}
                      style={{ width: '50%' }}
                    >
                      <FontAwesomeIcon
                        className="icon_btn"
                        icon={faRightToBracket}
                      />
                      {isLoading ? "Загрузка..." : "Вход"}
                    </Button>
                  </div>
                </div>
                {log !== null && (
                  <div className="row mb-3">
                    <div className="col-lg-12 log_form_light">{log}</div>
                  </div>
                )}
                <div className="row">
                  <div className="col-lg-12">
                    <a href="" className="block_form_link">Забыли пароль?</a>
                  </div>
                  <div className="col-lg-12">
                    <a href="/registration" className="block_form_link">Регистрация</a>
                  </div>
                </div>
                <div className="text-center fw-bold mt-15 mb-15">ИЛИ</div>
                <ExternalAuth />
              </div>
            </div>
            <div className="col-lg-4"></div>
          </div>
        </Container>
      ) : (
        <>
          <h1 className="text-center mt-5">Вы вошли как, {userData.Name}</h1>
          <div className="text-center mt-2">Выберите сервис для входа:</div>
          <div className="srv_block mt-5">
            <a href={process.env.REACT_APP_DOMAIN_TRACKER + "/lk"}>
              <div className="srv_card">
                <div className="header">Трекер задач</div>
              </div>
            </a>
          </div>
        </>
      )}
    </>
  );
}

export default Login;
